import { FC } from 'react'
// import { LANDING_ROOT_LINK } from 'src/constants/links'

/**
Пример тела сообщения:
  <ul className="list-inside list-disc">
    <li>В&nbsp;г. Брянске открылся терминал по&nbsp;адресу: ул. Марии Расковой, д.&nbsp;25, к.&nbsp;11.</li>
    <li>
      Запущен переход на&nbsp;новую маршрутную сеть для Рязанской области, г. Нижневартовск, ряда населенных
      пунктов Вологодской области, в&nbsp;т.ч.&nbsp;г. Череповец, более подробная информация{' '}
      <a className="link cursor-pointer" href={`${LANDING_ROOT_LINK}/info/2025-06-04`}>
        здесь
      </a>
      .
    </li>
  </ul>
*/

export const MainWarning: FC = function MainWarning() {
  return null
  // return (
  //   <div className="bg-attention-container">
  //     <div className="mx-auto px-4 py-3 text-center md:px-8 md:py-3">
  //       Внимание! Закрыт приём грузов на&nbsp;отправку в&nbsp;городах Брянск и&nbsp;Тамбов. Терминалы продолжают
  //       работать только на&nbsp;выдачу и&nbsp;доставку.
  //     </div>
  //   </div>
  // )
}
